import {globalSettings} from "../globalSettings";
import type {NotificationCenter} from "../../src/components/notification-center/notification-center";

import {html} from "lit";
import type {Meta, StoryObj} from "@storybook/web-components";

const meta: Meta<NotificationCenter> = {
	title: "Notification/Notification Center",
	component: "uxn-notification-center",

	argTypes: {
		customSettingsUrl: {control: "text"},
		locale: {control: "text"},
		stage: {control: "select", options: ["PROD", "QA", "INT"]},
		debug: {control: "boolean"},
	},
};

export default meta;
type Story = StoryObj<NotificationCenter>;

export const Default: Story = {
	args: {
		customSettingsUrl: "",
		locale: globalSettings.locale,
		stage: globalSettings.stage,
		debug: globalSettings.debug,
	},

	render: ({customSettingsUrl, locale, stage, debug}) =>
		html` <fragment>
			<a data-name="notifications">
				<span class="ux-iws-navigation-meta__icon-box">
					<uxn-notification-bell></uxn-notification-bell>
				</span>
				<span class="ux-iws-navigation-meta__link-text">Notifications</span>
			</a>
			<ux-tooltip tooltip-target="a[data-name='notifications']" align="bottom">
				<uxn-notification-center custom-settings-url="${customSettingsUrl}" locale="${locale}" stage="${stage}" debug="${debug}"></uxn-notification-center>
			</ux-tooltip>
		</fragment>`,
};

export const ArbitraryContainer: Story = {
	args: {
		...Default.args,
	},

	render: ({customSettingsUrl, locale, stage, debug}) =>
		html` <div id="someArbitraryContainer" style="width: 300px; height: 300px; overflow-y: scroll; padding: 0 8px; border: 1px dotted lightgray">
			<uxn-notification-center custom-settings-url="${customSettingsUrl}" locale="${locale}" stage="${stage}" debug="${debug}"></uxn-notification-center>
		</div>`,
};
